var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"mapContainer",staticClass:"mapboxgl-map",class:{
      inactive: _vm.inactive,
    }},_vm._l((_vm.buildings),function(building){return _c('MapBuilding',{key:building.id,attrs:{"map":_vm.map,"building":building,"zoom":_vm.zoomLevel},on:{"building-pressed":_vm.onBuildingPressed}})}),1),(_vm.config.debug && _vm.mapLoaded)?_c('MapDebug',{attrs:{"map":_vm.map}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }